import useCreate from "@/hooks/use-create";
import { UseLoadingReturn } from "@/hooks/use-loading";
import { IOrderInvoiced } from "@/interfaces/order-status.interfaces";
import orderStatusService from "@/services/order-status.service";
import { RequestsProps } from "@/types/requests.types";

export type InvoiceOrderProps = {
  formData: IOrderInvoiced;
} & RequestsProps;

export type UseInvoiceOrderReturn = {
  create: (props: InvoiceOrderProps) => Promise<void>;
} & UseLoadingReturn;

const useInvoiceOrder = (): UseInvoiceOrderReturn => {
  const { isLoading, startLoading, endLoading, loadingIcon, create } = useCreate<IOrderInvoiced>({
    operation: (formData) => orderStatusService.invoice(formData),
  });

  return {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    create,
  };
};

export default useInvoiceOrder;
